import { defineStore as G } from "@gitcoffee/store";
import { storage as k, getItem as V, setItem as Q } from "@gitcoffee/storage";
import { ref as w, computed as U, watch as W } from "vue";
import { defaultBaseSettingData as H, syncSet as z, syncGet as _ } from "@gitcoffee/core";
import { message as d } from "@gitcoffee/design-ui";
import { $t as g } from "@gitcoffee/i18n";
const C = [
  { name: "AI对话", code: "ai_chat", icon: "🤖" },
  { name: "AI搜索", code: "ai_search", icon: "🤖" },
  { name: "传统搜索", code: "traditional_search", icon: "🔍" },
  { name: "社交媒体", code: "social_media", icon: "📱" },
  { name: "学术搜索", code: "academic_search", icon: "🎓" },
  { name: "IT社区", code: "it_community", icon: "💻" },
  { name: "代码搜索", code: "code_search", icon: "🖥️" },
  { name: "依赖包搜索", code: "package_search", icon: "📦" },
  { name: "容器搜索", code: "container_search", icon: "🐳" }
], j = [
  // 国内平台放在前面
  {
    name: "文心搜索",
    code: "wenxin_search",
    description: "百度的文心AI搜索引擎",
    category: "AI搜索",
    url: "https://chat.baidu.com/",
    searchUrl: (e) => `https://chat.baidu.com/search?word=${encodeURIComponent(e)}`,
    tags: ["CN", "AI"]
  },
  {
    name: "纳米搜索",
    code: "nami_search",
    description: "纳米搜索AI搜索引擎",
    category: "AI搜索",
    url: "https://www.n.cn",
    searchUrl: (e) => `https://www.n.cn/?q=${encodeURIComponent(e)}`,
    tags: ["CN", "AI"]
  },
  {
    name: "秘塔",
    code: "metaso",
    description: "秘塔AI搜索引擎",
    category: "AI搜索",
    url: "https://metaso.cn",
    searchUrl: (e) => `https://metaso.cn/?q=${encodeURIComponent(e)}`,
    tags: ["CN", "AI"]
  },
  {
    name: "Felo Search",
    code: "felo_search",
    description: "Felo Search AI搜索引擎",
    category: "AI搜索",
    url: "https://felo.ai",
    searchUrl: (e) => `https://felo.ai/?q=${encodeURIComponent(e)}`,
    tags: ["CN", "AI"]
  },
  {
    name: "Miku",
    code: "miku",
    description: "Miku AI搜索引擎",
    category: "AI搜索",
    url: "https://hellomiku.com",
    searchUrl: (e) => `https://hellomiku.com/search?q=${encodeURIComponent(e)}`,
    tags: ["CN", "AI"]
  },
  // 国外平台放在后面
  // {
  //   name: 'Perplexity AI',
  //   code: 'perplexity_ai',
  //   description: 'AI驱动的搜索引擎',
  //   category: 'AI搜索',
  //   url: 'https://www.perplexity.ai',
  //   searchUrl: (q: string) =>
  //     `https://www.perplexity.ai/search?q=${encodeURIComponent(q)}`,
  //   tags: ['EN', 'AI'],
  // },
  {
    name: "Bing AI",
    code: "bing_ai",
    description: "微软的AI增强搜索引擎",
    category: "AI搜索",
    url: "https://search.yahoo.com/search",
    searchUrl: (e) => `https://search.yahoo.com/search?q=${encodeURIComponent(e)}`,
    tags: ["EN", "AI"]
  },
  {
    name: "You.com",
    code: "you_com",
    description: "AI增强的搜索引擎",
    category: "AI搜索",
    url: "https://you.com",
    searchUrl: (e) => `https://you.com/search?q=${encodeURIComponent(e)}`,
    tags: ["EN", "AI"]
  },
  // {
  //   name: 'Kagi',
  //   code: 'kagi',
  //   description: '注重隐私的AI搜索引擎',
  //   category: 'AI搜索',
  //   url: 'https://kagi.com',
  //   searchUrl: (q: string) =>
  //     `https://kagi.com/search?q=${encodeURIComponent(q)}`,
  //   tags: ['EN', 'AI'],
  // },
  // {
  //   name: 'Searxng',
  //   code: 'searxng',
  //   description: '开源的元搜索引擎',
  //   category: 'AI搜索',
  //   url: 'https://searxng.org',
  //   searchUrl: (q: string) =>
  //     `https://searxng.org/search?q=${encodeURIComponent(q)}`,
  //   tags: ['EN', 'AI'],
  // },
  {
    name: "WebPilot",
    code: "webpilot",
    description: "WebPilot AI搜索引擎",
    category: "AI搜索",
    url: "https://www.webpilot.ai",
    searchUrl: (e) => `https://www.webpilot.ai/search?q=${encodeURIComponent(e)}`,
    tags: ["EN", "AI"]
  },
  {
    name: "Consensus",
    code: "consensus",
    description: "Consensus AI搜索引擎",
    category: "AI搜索",
    url: "https://consensus.app",
    searchUrl: (e) => `https://consensus.app/results/?q=${encodeURIComponent(e)}`,
    tags: ["EN", "AI"]
  },
  {
    name: "Phind",
    code: "phind",
    description: "Phind AI搜索引擎",
    category: "AI搜索",
    url: "https://www.phind.com",
    searchUrl: (e) => `https://www.phind.com/search?q=${encodeURIComponent(e)}`,
    tags: ["EN", "AI"]
  },
  // {
  //   name: 'SEMANTIC SCHOLAR',
  //   code: 'semantic_scholar',
  //   description: 'Semantic Scholar学术搜索引擎',
  //   category: 'AI搜索',
  //   url: 'https://www.semanticscholar.org',
  //   searchUrl: (q: string) =>
  //     `https://www.semanticscholar.org/search?q=${encodeURIComponent(q)}`,
  //   tags: ['EN', 'AI'],
  // },
  // {
  //   name: 'Genspark',
  //   code: 'genspark',
  //   description: 'Genspark AI搜索引擎',
  //   category: 'AI搜索',
  //   url: 'https://www.genspark.ai',
  //   searchUrl: (q: string) =>
  //     `https://www.genspark.ai/search?query=${encodeURIComponent(q)}`,
  //   tags: ['EN', 'AI'],
  // },
  // {
  //   name: 'Monica',
  //   code: 'monica',
  //   description: 'Monica AI搜索引擎',
  //   category: 'AI搜索',
  //   url: 'https://s.monica.im',
  //   searchUrl: (q: string) =>
  //     `https://s.monica.im/search?q=${encodeURIComponent(q)}`,
  //   tags: ['EN', 'AI'],
  // },
  {
    name: "Exa",
    code: "exa",
    description: "Exa AI搜索引擎",
    category: "AI搜索",
    url: "https://exa.ai",
    searchUrl: (e) => `https://exa.ai/search?q=${encodeURIComponent(e)}`,
    tags: ["EN", "AI"]
  }
], J = [
  // 国内平台放在前面
  {
    name: "百度",
    code: "baidu",
    description: "中国最大的搜索引擎",
    category: "传统搜索",
    url: "https://www.baidu.com",
    searchUrl: (e) => `https://www.baidu.com/s?wd=${encodeURIComponent(e)}`,
    tags: ["CN"]
  },
  {
    name: "搜狗搜索",
    code: "sogou_search",
    description: "搜狐旗下的搜索引擎",
    category: "传统搜索",
    url: "https://www.sogou.com",
    searchUrl: (e) => `https://www.sogou.com/web?query=${encodeURIComponent(e)}`,
    tags: ["CN"]
  },
  {
    name: "360搜索",
    code: "360_search",
    description: "360旗下的搜索引擎",
    category: "传统搜索",
    url: "https://www.so.com",
    searchUrl: (e) => `https://www.so.com/s?q=${encodeURIComponent(e)}`,
    tags: ["CN"]
  },
  {
    name: "必应国内版",
    code: "bing_cn",
    description: "微软必应国内版搜索引擎",
    category: "传统搜索",
    url: "https://cn.bing.com",
    searchUrl: (e) => `https://cn.bing.com/search?q=${encodeURIComponent(e)}`,
    tags: ["CN"]
  },
  {
    name: "神马搜索",
    code: "shenma_search",
    description: "阿里巴巴旗下的搜索引擎",
    category: "传统搜索",
    url: "https://www.sm.cn",
    searchUrl: (e) => `https://www.sm.cn/s?q=${encodeURIComponent(e)}`,
    tags: ["CN"]
  },
  {
    name: "头条搜索",
    code: "toutiao_search",
    description: "字节跳动旗下的搜索引擎",
    category: "传统搜索",
    url: "https://so.toutiao.com",
    searchUrl: (e) => `https://so.toutiao.com/search?dvpf=pc&source=input&keyword=${encodeURIComponent(e)}`,
    tags: ["CN"]
  },
  // 国外平台放在后面
  {
    name: "Google",
    code: "google",
    description: "全球最大的搜索引擎",
    category: "传统搜索",
    url: "https://www.google.com",
    searchUrl: (e) => `https://www.google.com/search?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "Bing",
    code: "bing",
    description: "微软的搜索引擎",
    category: "传统搜索",
    url: "https://www.bing.com",
    searchUrl: (e) => `https://www.bing.com/search?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "DuckDuckGo",
    code: "duckduckgo",
    description: "注重隐私的搜索引擎",
    category: "传统搜索",
    url: "https://duckduckgo.com",
    searchUrl: (e) => `https://duckduckgo.com/?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "Yahoo",
    code: "yahoo",
    description: "美国传统搜索引擎",
    category: "传统搜索",
    url: "https://www.yahoo.com",
    searchUrl: (e) => `https://search.yahoo.com/search?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "Ask.com",
    code: "ask_com",
    description: "传统问答式搜索引擎",
    category: "传统搜索",
    url: "https://www.ask.com",
    searchUrl: (e) => `https://www.ask.com/web?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "Aol Search",
    code: "aol_search",
    description: "美国在线搜索引擎",
    category: "传统搜索",
    url: "https://search.aol.com",
    searchUrl: (e) => `https://search.aol.com/aol/search?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "Lycos",
    code: "lycos",
    description: "历史悠久的搜索引擎",
    category: "传统搜索",
    url: "https://www.lycos.com",
    searchUrl: (e) => `https://search.lycos.com/web/?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "WebCrawler",
    code: "webcrawler",
    description: "最早的搜索引擎之一",
    category: "传统搜索",
    url: "https://www.webcrawler.com",
    searchUrl: (e) => `https://www.webcrawler.com/serp?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  },
  {
    name: "Excite",
    code: "excite",
    description: "传统门户网站搜索引擎",
    category: "传统搜索",
    url: "https://www.excite.com",
    searchUrl: (e) => `https://results.excite.com/web/results?q=${encodeURIComponent(e)}`,
    tags: ["EN"]
  }
], M = [
  ...j,
  ...J
], D = (e) => {
  let t = C.find((a) => a.code === e);
  return t || (t = C.find((a) => a.name === e)), t ? t.code === "ai_chat" || t.name === "AI对话" ? [] : M.filter((a) => a.category === t.name) : [];
}, $ = [
  { key: "CN", name: "国内", sort: 1 },
  { key: "EN", name: "国际", sort: 2 },
  { key: "AI", name: "人工智能", sort: 3 },
  { key: "ACAD", name: "学术", sort: 4 },
  { key: "IT", name: "技术", sort: 5 },
  { key: "CODE", name: "代码", sort: 6 },
  { key: "PKG", name: "依赖包", sort: 7 },
  { key: "CONTAINER", name: "容器", sort: 8 }
], ge = C.reduce(
  (e, t) => (e[t.code] = D(t.name), e),
  {}
), v = {
  // 从 @gitcoffee/core 继承基础设置
  ...H,
  // 搜索设置
  smartSearchEnabled: null,
  // 不设置默认值，以config.ts中的配置为准
  aiModeSearch: null,
  // 不设置默认值，以config.ts中的配置为准
  searchHistoryEnabled: !1,
  showSearchEngineSelector: !0,
  // 搜索框设置
  defaultSearchType: "search",
  enableSearchTypeToggle: !0,
  // 搜索平台显示设置
  searchPlatforms: [
    { type: "tabs", enabled: !0, order: 1 },
    { type: "categories", enabled: !0, order: 2 },
    { type: "grid", enabled: !0, order: 3 },
    { type: "list", enabled: !0, order: 4 }
  ],
  // 标签显示设置
  tags: [],
  // 初始为空，在loadSettingsFromLocalStorage中与tagDefinitions同步
  // 搜索引擎列表
  searchEngines: ["百度", "搜狗搜索", "Perplexity AI", "You.com", "Kagi", "ChatGPT Search", "Gemini Search", "Bing AI"]
}, Y = () => {
  try {
    const e = { ...v };
    let t, a;
    typeof window < "u" && (t = window.__GLOBAL_SMART_SEARCH_DEFAULT__, a = window.__GLOBAL_AI_MODE_SEARCH_DEFAULT__), t !== void 0 && (e.smartSearchEnabled = t), a !== void 0 && (e.aiModeSearch = a);
    const s = _("searchSettings");
    if (s)
      try {
        const i = JSON.parse(s), f = { ...e, ...i };
        return f.smartSearchEnabled = e.smartSearchEnabled, f.aiModeSearch = e.aiModeSearch, f;
      } catch (i) {
        console.error("Failed to parse unified search settings:", i);
      }
    const r = _("appSettings");
    if (r)
      try {
        const i = JSON.parse(r), f = { ...e, ...i };
        return f.smartSearchEnabled = e.smartSearchEnabled, f.aiModeSearch = e.aiModeSearch, f;
      } catch (i) {
        console.error("Failed to parse unified app settings:", i);
      }
    ["enableLanguageSetting", "language", "enableThemeSetting", "theme", "openMode", "notificationEnabled", "soundEnabled", "dataStorage", "autoBackupEnabled", "templateEnabled", "defaultTemplate", "isBrowserTab", "activeCollapseKeys"].forEach((i) => {
      const f = `setting_${i}`, h = _(f);
      if (h !== null)
        try {
          const p = JSON.parse(h), m = i;
          m === "activeCollapseKeys" ? Array.isArray(p) && (e[m] = p) : e[m] = p;
        } catch {
          const m = i;
          m !== "activeCollapseKeys" && (e[m] = h);
        }
    }), ["searchHistoryEnabled", "showSearchEngineSelector", "defaultSearchType", "enableSearchTypeToggle", "searchPlatforms", "tags", "searchEngines"].forEach((i) => {
      const f = `search_setting_${i}`;
      let h = _(f);
      if (h === null) {
        const p = `setting_${i}`;
        h = _(p);
      }
      if (h !== null)
        try {
          const p = JSON.parse(h), m = i;
          m === "searchPlatforms" || m === "tags" ? Array.isArray(p) && (e[m] = p) : e[m] = p;
        } catch {
          const m = i;
          m !== "searchPlatforms" && m !== "tags" && (e[m] = h);
        }
    }), (e.searchPlatforms || v.searchPlatforms).filter((i) => i.enabled).length === 0 && (e.searchPlatforms = [
      ...e.searchPlatforms || v.searchPlatforms
    ], e.searchPlatforms[0].enabled = !0);
    const u = Array.isArray(e.tags) ? e.tags : [], b = new Map(u.map((i) => [i.key, i]));
    return e.tags = $.map((i, f) => {
      const h = b.get(i.key), p = h && typeof h == "object" && "enabled" in h && "order" in h;
      return {
        key: i.key,
        enabled: p && h.enabled !== void 0 ? h.enabled : !0,
        order: p && h.order ? h.order : f + 1
      };
    }), e.smartSearchEnabled !== !1 ? e.showSearchEngineSelector = !1 : e.showSearchEngineSelector = !0, e;
  } catch (e) {
    console.error("Failed to load settings from storage:", e);
    const t = { ...v };
    return t.tags = $.map((a, s) => ({
      key: a.key,
      enabled: !0,
      order: s + 1
    })), t;
  }
}, X = async () => {
  try {
    const e = { ...c.value }, t = e.smartSearchEnabled, a = e.aiModeSearch, s = await k.get("searchSettings");
    if (s)
      Object.assign(e, s), e.smartSearchEnabled = t, e.aiModeSearch = a;
    else {
      const r = await k.get("appSettings");
      if (r)
        Object.assign(e, r), e.smartSearchEnabled = t, e.aiModeSearch = a;
      else {
        const n = ["enableLanguageSetting", "language", "enableThemeSetting", "theme", "openMode", "notificationEnabled", "soundEnabled", "dataStorage", "autoBackupEnabled", "templateEnabled", "defaultTemplate", "isBrowserTab", "activeCollapseKeys"];
        for (const y of n) {
          const u = `setting_${y}`, b = await k.get(u);
          if (b !== void 0) {
            const i = y;
            e[i] = b;
          }
        }
      }
      const o = ["searchHistoryEnabled", "showSearchEngineSelector", "defaultSearchType", "enableSearchTypeToggle", "searchPlatforms", "tags", "searchEngines"];
      for (const n of o) {
        const y = `search_setting_${n}`, u = await k.get(y);
        if (u !== void 0) {
          const b = n;
          e[b] = u;
        }
      }
    }
    if (e.tags) {
      const r = Array.isArray(e.tags) ? e.tags : [], o = new Map(
        r.map((n) => [n.key, n])
      );
      e.tags = $.map((n, y) => {
        const u = o.get(n.key), b = u && typeof u == "object" && "enabled" in u && "order" in u;
        return {
          key: n.key,
          enabled: b && u.enabled !== void 0 ? u.enabled : !0,
          order: b && u.order ? u.order : y + 1
        };
      });
    }
    if (e.searchPlatforms) {
      const r = Array.isArray(e.searchPlatforms) ? e.searchPlatforms : v.searchPlatforms;
      r.filter(
        (n) => n.enabled
      ).length === 0 && r.length > 0 ? (e.searchPlatforms = [...r], e.searchPlatforms[0].enabled = !0) : e.searchPlatforms = r;
    }
    e.smartSearchEnabled ? e.showSearchEngineSelector = !1 : e.showSearchEngineSelector = !0, c.value = e;
  } catch (e) {
    console.error("Failed to load settings from async storage:", e), c.value = v;
  }
}, ue = w([
  "market",
  "plugins",
  "account",
  "backup",
  "feedback",
  "about",
  "system",
  "language",
  "theme",
  "ui",
  "interaction",
  "data",
  "dataManagement",
  "template",
  "search",
  "searchBox",
  "searchPlatforms",
  "tags"
]), c = w(Y()), me = () => c, S = () => {
  try {
    z("searchSettings", JSON.stringify(c.value)), (async () => {
      try {
        await k.set("searchSettings", c.value);
      } catch (e) {
        console.error("Failed to save search settings to async storage:", e);
      }
    })();
  } catch (e) {
    console.error("Failed to save search settings to storage:", e);
  }
}, pe = (e) => {
  const t = c.value.searchPlatforms.find((a) => a.type === e);
  t && (t.enabled = !t.enabled, S());
}, fe = (e) => {
  const t = c.value.tags.find((a) => a.key === e);
  t && (t.enabled = !t.enabled, S());
}, we = (e) => {
  c.value.tags = e, S();
}, ye = U(() => c.value.searchPlatforms.filter((e) => e.enabled).map((e) => e.type)), Se = U(() => c.value.tags.filter((e) => e.enabled).map((e) => e.key)), be = U(() => [...c.value.tags].sort((e, t) => e.order - t.order)), ve = (e) => {
  switch (e) {
    case "tabs":
      return "标签页";
    case "categories":
      return "分类";
    case "grid":
      return "网格";
    case "list":
      return "列表";
    default:
      return e;
  }
}, Ae = (e) => $.find((a) => a.key === e)?.name || e, Pe = (e, t) => {
  const a = c.value.searchPlatforms, s = a.findIndex((n) => n.type === e);
  if (s === -1) return;
  const r = t === "up" ? s - 1 : s + 1;
  if (r < 0 || r >= a.length) return;
  const o = a[s].order;
  a[s].order = a[r].order, a[r].order = o, S();
}, Ce = (e, t) => {
  const a = c.value.searchPlatforms.find((s) => s.type === e);
  return a ? !t && c.value.searchPlatforms.filter((r) => r.enabled).length <= 1 ? !1 : (a.enabled = t, S(), !0) : !1;
}, Ee = (e, t) => {
  const a = c.value.tags, s = a.findIndex((n) => n.key === e);
  if (s === -1) return;
  const r = t === "up" ? s - 1 : s + 1;
  if (r < 0 || r >= a.length) return;
  const o = a[s].order;
  a[s].order = a[r].order, a[r].order = o, S();
}, Ie = (e, t) => {
  const a = c.value.tags.find((s) => s.key === e);
  a && (a.enabled = t, S());
}, Ue = (e) => {
  c.value = { ...c.value, ...e }, S();
}, Te = () => {
  c.value = { ...v }, S();
};
c.value = new Proxy(c.value, {
  set(e, t, a) {
    return e[t] = a, S(), !0;
  }
});
const _e = X, ke = G("search", {
  state: () => ({
    // 搜索相关状态
    searchQuery: "",
    selectedSearchEngine: "百度",
    searchResults: [],
    loading: !1,
    error: "",
    totalResults: 0,
    currentPage: 1,
    pageSize: 20,
    relatedSearches: [],
    activeTabKey: "all",
    showSettingModal: !1,
    // 加载状态
    isLoading: !1,
    // 折叠面板相关状态
    activeCollapseKeys: ["market", "plugins", "account", "backup", "feedback", "about", "system", "language", "theme", "ui", "interaction", "data", "dataManagement", "template", "search", "searchBox", "searchPlatforms", "tags"],
    // 设置相关状态 - 从setting.data中获取默认值，避免重复定义
    settingData: v,
    // API配置
    searchApiConfig: {
      url: "/api/search",
      method: "GET",
      timeout: 3e4
    }
  }),
  getters: {
    // 计算属性：是否有搜索结果
    hasSearchResults: (e) => e.searchResults.length > 0,
    // 计算属性：是否正在搜索
    isSearching: (e) => e.loading,
    // 计算属性：当前主题
    currentTheme: (e) => e.settingData.theme,
    // 计算属性：当前语言
    currentLanguage: (e) => e.settingData.language,
    // 计算属性：启用的搜索引擎
    enabledSearchEngines: (e) => e.settingData.searchEngines
  },
  actions: {
    // 设置搜索查询
    setSearchQuery(e) {
      this.searchQuery = e, this.currentPage = 1;
    },
    // 设置搜索引擎
    setSelectedSearchEngine(e) {
      this.selectedSearchEngine = e;
    },
    // 设置API配置
    setApiConfig(e) {
      this.searchApiConfig = { ...this.searchApiConfig, ...e };
    },
    // 设置活动标签页
    setActiveTabKey(e) {
      this.activeTabKey = e;
    },
    // 设置当前页码
    setCurrentPage(e) {
      this.currentPage = e;
    },
    // 设置设置数据
    updateSettingData(e) {
      this.settingData = { ...this.settingData, ...e };
    },
    // 更新主题
    updateTheme(e) {
      this.settingData.theme = e;
    },
    // 更新语言
    updateLanguage(e) {
      this.settingData.language = e;
    },
    // 更新插件
    updatePlugin(e, t) {
      this.settingData.plugins && (this.settingData.plugins[e] = t);
    },
    // 异步获取搜索结果
    async fetchSearchResults() {
      if (!(!this.searchQuery || this.loading)) {
        this.loading = !0, this.error = "";
        try {
          if (!this.searchApiConfig.url)
            throw new Error("Search API URL is not configured");
          let e, t;
          if (this.searchApiConfig.url.startsWith("http://") || this.searchApiConfig.url.startsWith("https://"))
            e = new URL(this.searchApiConfig.url), t = e.searchParams;
          else {
            const r = window.location.origin;
            e = new URL(this.searchApiConfig.url, r), t = e.searchParams;
          }
          t.append("categoryId", ""), t.append("keyword", this.searchQuery), t.append("pageNo", this.currentPage.toString()), t.append("size", this.pageSize.toString());
          const a = await fetch(e.toString(), {
            method: this.searchApiConfig.method,
            headers: {
              "Content-Type": "application/json",
              ...this.searchApiConfig.headers || {}
            }
          });
          if (!a.ok)
            throw new Error("请求失败");
          const s = await a.json();
          if (s.succeed)
            this.searchResults = (s.data.list || []).map((r) => ({
              id: r.id,
              source: r.source,
              title: r.title,
              url: this.searchApiConfig.urlTemplate ? this.searchApiConfig.urlTemplate.replace("{id}", r.id) : `https://code.exmay.com/exmay/ugc/article/detail/${r.id}`,
              // 构造文章URL
              description: r.contentInfo ? r.contentInfo.title : "",
              // 使用标题作为描述
              tags: r.tags || [],
              timestamp: new Date(r.publishTime),
              breadcrumb: []
              // 新API没有面包屑数据
            })), this.totalResults = parseInt(s.data.total || "0"), this.relatedSearches = [];
          else
            throw new Error(s.msg || "搜索失败");
        } catch (e) {
          this.error = e.message, console.error("Search failed:", e);
        } finally {
          this.loading = !1;
        }
      }
    },
    // 重置搜索状态
    resetSearchState() {
      this.searchResults = [], this.loading = !1, this.error = "", this.totalResults = 0, this.currentPage = 1, this.relatedSearches = [];
    },
    // 跳转到搜索引擎
    navigateToSearchEngine() {
      if (!this.searchQuery) return;
      const t = {
        智能搜索: "https://search.example.com?q={q}",
        百度: "https://www.baidu.com/s?wd={q}",
        搜狗搜索: "https://www.sogou.com/web?query={q}",
        "Perplexity AI": "https://www.perplexity.ai/search?q={q}",
        "You.com": "https://you.com/search?q={q}",
        Kagi: "https://kagi.com/search?q={q}",
        "ChatGPT Search": "https://chat.openai.com/search?q={q}",
        "Gemini Search": "https://gemini.google.com/search?q={q}",
        "Bing AI": "https://www.bing.com/chat?q={q}"
      }[this.selectedSearchEngine];
      t && (window.location.href = t.replace("{q}", encodeURIComponent(this.searchQuery)));
    },
    // 初始化搜索状态
    initializeSearch(e) {
      e && (this.searchQuery = e), this.resetSearchState();
    },
    // 初始化设置
    async initialize() {
      this.isLoading = !0;
      try {
        await this.loadSettingsFromStorage();
        const e = window.__GLOBAL_SMART_SEARCH_DEFAULT__;
        e !== void 0 && (this.settingData.smartSearchEnabled = e, e ? this.settingData.showSearchEngineSelector = !1 : this.settingData.showSearchEngineSelector = !0);
        const t = window.__GLOBAL_AI_MODE_SEARCH_DEFAULT__;
        t !== void 0 && (this.settingData.aiModeSearch = t);
      } catch (e) {
        console.error("Failed to initialize search settings:", e);
      } finally {
        this.isLoading = !1;
      }
    },
    // 保存设置到存储
    async saveSettingsToStorage() {
      try {
        await Q("searchSettings", JSON.stringify(this.settingData));
      } catch (e) {
        console.error("Failed to save settings to storage:", e);
      }
    },
    // 从存储加载设置
    async loadSettingsFromStorage() {
      try {
        const e = await V("appSettings");
        e && (this.settingData = { ...this.settingData, ...JSON.parse(e) });
      } catch (e) {
        console.error("Failed to load settings from storage:", e);
      }
    }
  }
}), Z = (e) => {
  let t;
  try {
    const a = e.startsWith("http") ? e : `https://${e}`;
    t = new URL(a).hostname;
  } catch {
    t = e;
  }
  return `https://favicon.im/${t}`;
}, ee = [
  { name: "默认搜索", code: "search", icon: "🔍", url: "/search", searchParam: "q", apiEnabled: !0, defaulted: !0 },
  { name: "百度", code: "baidu", icon: "🔍", url: "https://www.baidu.com/s", searchParam: "wd" },
  { name: "搜狗搜索", code: "sogou", icon: "🔎", url: "https://www.sogou.com/web", searchParam: "query" },
  { name: "360搜索", code: "360", icon: "🔍", url: "https://www.so.com/s", searchParam: "q" },
  { name: "神马搜索", code: "shenma", icon: "🐴", url: "https://www.sm.cn/s", searchParam: "q" },
  { name: "今日头条搜索", code: "toutiao", icon: "📰", url: "https://so.toutiao.com/search", searchParam: "q" },
  // { name: '抖音搜索', code: 'douyin', icon: '🎵', url: 'https://www.douyin.com/search', searchParam: 'keyword' }, // 不支持通过URL参数直接搜索
  { name: "知乎搜索", code: "zhihu", icon: "❓", url: "https://www.zhihu.com/search", searchParam: "q" },
  { name: "微博搜索", code: "weibo", icon: "💬", url: "https://s.weibo.com/weibo", searchParam: "q" },
  { name: "Bing AI", code: "bing", icon: "🅱️", url: "https://www.bing.com/search", searchParam: "q" },
  { name: "Google", code: "google", icon: "🔍", url: "https://www.google.com/search", searchParam: "q" },
  { name: "Yahoo", code: "yahoo", icon: "📧", url: "https://search.yahoo.com/search", searchParam: "p" },
  { name: "Perplexity AI", code: "perplexity", icon: "🤖", url: "https://www.perplexity.ai/search", searchParam: "q" },
  { name: "You.com", code: "you", icon: "💡", url: "https://you.com/search", searchParam: "q" }
  // { name: 'Kagi', code: 'kagi', icon: '🔒', url: 'https://kagi.com/search', searchParam: 'q' }, // 不支持通过URL参数直接搜索（需要登录）
  // { name: 'ChatGPT Search', code: 'chatgpt', icon: '🧠', url: 'https://chat.openai.com/search', searchParam: 'q' }, // 不支持通过URL参数直接搜索（需要登录）
  // { name: 'Gemini Search', code: 'gemini', icon: '🌐', url: 'https://gemini.google.com/search', searchParam: 'q' }, // 不支持通过URL参数直接搜索（需要登录）
], E = ee.map((e) => ({
  ...e,
  iconUrl: Z(e.url),
  api: e.api || "",
  apiEnabled: e.apiEnabled || !1
})), R = w("tabs"), A = w("AI对话"), l = w([]), N = w(!1), x = w([]), B = w(M), xe = (e) => {
  B.value = e;
}, P = U(() => B.value), te = U(() => C.filter((e) => T(e.name).length > 0)), T = (e) => {
  let t = C.find((a) => a.code === e);
  return t || (t = C.find((a) => a.name === e)), t ? P.value.filter(
    (a) => a.category === t.name
  ) : [];
}, Re = U(() => c.value?.searchPlatforms ? c.value.searchPlatforms.filter((e) => e?.enabled).sort((e, t) => (e?.order || 0) - (t?.order || 0)) : []), Ne = U(() => {
  const e = /* @__PURE__ */ new Set();
  P.value.forEach((a) => {
    a?.tags && Array.isArray(a.tags) && a.tags.forEach((s) => {
      s && e.add(s);
    });
  });
  const t = Array.isArray(c.value?.tags) ? c.value.tags : [];
  return Array.from(e).filter((a) => t.find((r) => r.key === a)?.enabled !== !1).sort((a, s) => {
    const r = t.find((n) => n.key === a), o = t.find((n) => n.key === s);
    return r && o ? (r.order || 0) - (o.order || 0) : r ? -1 : o ? 1 : a.localeCompare(s);
  });
}), $e = (e) => {
  if (!e)
    return "🔍";
  let t = C.find((a) => a.name === e);
  return t || (t = C.find((a) => a.code === e)), t?.icon || "🔍";
};
let I = null;
const qe = (e) => {
  I = e;
}, De = (e) => {
  const t = l.value.indexOf(e);
  if (t > -1)
    l.value.splice(t, 1);
  else {
    if (I && !I(e, [...l.value]))
      return;
    l.value.push(e);
  }
  q();
}, Me = (e) => {
  const t = T(e), a = t.map((r) => r.code);
  return l.value.filter(
    (r) => a.includes(r)
  ).length === t.length;
}, Ke = (e, t) => {
  const s = T(e).map((o) => o.code), r = l.value.filter((o) => {
    const n = P.value.find((y) => y.code === o);
    return n && n.category !== e;
  });
  if (t) {
    let o = [...s];
    I && (o = o.filter(
      (n) => I(n, [...r])
    )), l.value = [...r, ...o];
  } else
    l.value = r;
  q();
}, Fe = () => {
  N.value = !N.value;
  let e = [];
  R.value === "tabs" ? e = T(A.value) : e = P.value;
  const t = e.map((a) => a.code);
  if (N.value) {
    let a = [...t];
    if (I) {
      const s = l.value.filter(
        (r) => !t.includes(r)
      );
      a = a.filter(
        (r) => I(r, [...s])
      );
    }
    l.value = l.value.filter(
      (s) => !t.includes(s)
    ), l.value.push(...a);
  } else
    l.value = l.value.filter(
      (a) => !t.includes(a)
    );
  q();
}, Le = (e) => {
  const t = x.value.indexOf(e);
  t > -1 ? x.value.splice(t, 1) : x.value.push(e), ae();
}, ae = () => {
  let e = [...P.value];
  if (R.value === "tabs" && (e = T(A.value)), x.value.length === 0)
    l.value = l.value.filter((t) => {
      const a = P.value.find((s) => s.code === t);
      return a && a.category !== A.value;
    });
  else {
    const a = e.filter((s) => s.tags.some((r) => x.value.includes(r))).map((s) => s.code);
    R.value === "tabs" ? (l.value = l.value.filter(
      (s) => {
        const r = P.value.find(
          (o) => o.code === s
        );
        return r && r.category !== A.value;
      }
    ), l.value.push(...a)) : l.value = a;
  }
  q();
}, q = () => {
  let e = [];
  R.value === "tabs" ? e = T(A.value) : e = P.value;
  const t = e.map((s) => s.code), a = l.value.filter(
    (s) => t.includes(s)
  );
  N.value = a.length === e.length;
}, Oe = (e) => {
  R.value = e;
}, Be = (e) => {
  A.value = e;
};
W(
  () => te.value,
  (e) => {
    !e.some(
      (a) => a.name === A.value
    ) && e.length > 0 && (A.value = e[0].name);
  },
  { immediate: !0, deep: !0 }
);
const Ge = w(""), F = w(!1), re = E.find((e) => e.defaulted) || E[0], Ve = w(re.name), K = w(
  typeof window < "u" && !!window.chrome && window.chrome.runtime
), L = async (e, t) => {
  if (K.value)
    try {
      await chrome.runtime.sendMessage({
        action: "searchWithEngine",
        query: e.trim(),
        engine: t.code
      }), d.success(g("search.searching", { query: e }));
    } catch (a) {
      console.error("Traditional search failed in extension:", a), d.error(g("search.searchFailed"));
    }
  else
    try {
      const a = `${t.url}?${t.searchParam}=${encodeURIComponent(e.trim())}`;
      typeof window < "u" && window.open ? (window.open(a, "_blank"), d.success(g("search.openedInNewTab", { count: 1 }))) : (console.error("Cannot open new tab in this environment"), d.error(g("search.searchFailed")));
    } catch (a) {
      console.error("Traditional search failed in non-extension:", a), d.error(g("search.searchFailed"));
    }
}, O = async (e, t) => {
  if (K.value)
    try {
      await chrome.runtime.sendMessage({
        action: "searchWithApi",
        query: e.trim(),
        engine: t.code
      }), d.success(g("search.apiSearching", { query: e }));
    } catch (a) {
      console.error("API search failed in extension:", a), d.error(g("search.apiSearchFailed"));
    }
  else
    try {
      const a = encodeURIComponent(e.trim()), s = t.name || "默认搜索", o = `${t.url.startsWith("/") ? t.url : `/${t.url}`}?q=${a}&engine=${encodeURIComponent(s)}`;
      window.location.href = o, d.success(g("search.searching", { query: e }));
    } catch (a) {
      console.error("API search navigation failed:", a);
      const s = encodeURIComponent(e.trim()), r = `${t.url}?${t.searchParam}=${s}`;
      window.open(r, "_blank"), d.success(g("search.openedInNewTab", { count: 1 }));
    }
}, se = async (e, t, a) => {
  if (!c.value) {
    console.error("settingData is not available");
    return;
  }
  if (!e.trim()) {
    d.warning(g("search.pleaseEnterKeyword"));
    return;
  }
  const s = Array.isArray(t) && t.length > 0 ? t : Array.isArray(l.value) ? l.value : [];
  if (s.length === 0) {
    d.warning(g("search.pleaseSelectAtLeastOnePlatform"));
    return;
  }
  if (K.value)
    try {
      await chrome.runtime.sendMessage({
        action: "searchWithGrouping",
        query: e.trim(),
        platformNames: s,
        searchDelay: 100
      }), d.success(g("search.searching", { query: e, count: s.length }));
    } catch (r) {
      console.error("Intelligent search failed in extension:", r), d.error(g("search.searchFailed"));
    }
  else
    try {
      (a ? a() : M).filter(
        (n) => s.includes(n.code)
      ).forEach((n) => {
        const y = n.searchUrl(e.trim());
        window.open(y, "_blank");
      }), d.success(g("search.openedInNewTab", { count: s.length }));
    } catch (r) {
      console.error("Intelligent search failed in non-extension:", r), d.error(g("search.searchFailed"));
    }
}, oe = async (e, t, a, s) => {
  if (!e.trim()) {
    d.warning(g("search.pleaseEnterKeyword"));
    return;
  }
  F.value = !0;
  try {
    if (!c.value) {
      console.error("settingData is not available");
      return;
    }
    if (console.log("executeSearch - selectedPlatformCodes:", t), console.log("executeSearch - selectedPlatforms.value:", l.value), console.log("executeSearch - selectedSearchEngine:", a), a) {
      console.log("executeSearch - Non-smart search mode, using engine:", a);
      const r = E.find((o) => o.name === a) || E.find((o) => o.defaulted) || E[0];
      if (!r)
        throw new Error("No search engine found");
      r.apiEnabled ? await O(e.trim(), r) : await L(e.trim(), r);
    } else if (c.value.smartSearchEnabled !== !1) {
      const o = Array.isArray(t) && t.length > 0 ? t : Array.isArray(l.value) ? l.value : [];
      if (console.log("executeSearch - Smart search mode, actualSelectedPlatforms:", o), o.length === 0) {
        console.log("executeSearch - No platforms selected, showing warning"), d.warning(g("search.pleaseSelectAtLeastOnePlatform"));
        return;
      }
      await se(e.trim(), o, s);
    } else {
      const o = E.find((n) => n.defaulted) || E[0];
      if (!o)
        throw new Error("No search engine found");
      o.apiEnabled ? await O(e.trim(), o) : await L(e.trim(), o);
    }
  } catch (r) {
    console.error("Search failed:", r), d.error(g("search.searchFailed"));
  } finally {
    F.value = !1;
  }
}, Qe = async (e, t = "ai_chat", a) => {
  try {
    const { executeChat: s } = await import("@gitcoffee/chatbot"), o = D(t).map((n) => n.code);
    await s({
      query: e,
      platformCodes: o
    });
  } catch (s) {
    console.error("使用chatbot包执行AI对话失败，回退到旧的搜索逻辑：", s);
    const o = D(t).map((n) => n.code);
    await oe(e, o, void 0, a);
  }
};
function We(e) {
  return Promise.resolve({ results: [], query: e });
}
export {
  te as activeCategories,
  ue as activeCollapseKeys,
  P as activePlatforms,
  Ne as activeTags,
  M as allPlatforms,
  C as categories,
  me as createSettingData,
  v as defaultSettingData,
  R as displayMode,
  ye as enabledSearchEngines,
  Se as enabledTags,
  Qe as executeAISearch,
  oe as executeSearch,
  Re as filteredAndSortedPlatforms,
  T as getActivePlatformsByCategory,
  $e as getCategoryIcon,
  Z as getFaviconUrl,
  ve as getPlatformName,
  D as getPlatformsByCategory,
  Ae as getTagName,
  Be as handleCategoryChange,
  Ke as handleCategorySelectAll,
  Oe as handleDisplayModeChange,
  Ce as handlePlatformEnabledChange,
  Fe as handleSelectAll,
  Ie as handleTagEnabledChange,
  B as internalPlatforms,
  Me as isCategoryAllSelected,
  K as isChromeExtension,
  _e as loadChromeStorageSettings,
  X as loadSettingsFromAsyncStorage,
  Pe as movePlatform,
  Ee as moveTag,
  ge as platformsByCategory,
  we as reorderTags,
  Te as resetSettings,
  S as saveSettingsToStorage,
  We as search,
  E as searchEngines,
  Ge as searchQuery,
  F as searching,
  N as selectAllPlatforms,
  A as selectedCategory,
  l as selectedPlatforms,
  Ve as selectedSearchEngine,
  x as selectedTags,
  qe as setPlatformSelectionValidator,
  xe as setPlatforms,
  c as settingData,
  be as sortedTags,
  $ as tagDefinitions,
  De as togglePlatform,
  pe as toggleSearchEngine,
  fe as toggleSearchTag,
  Le as toggleTag,
  ae as updatePlatformsByTags,
  q as updateSelectAllStatus,
  Ue as updateSettings,
  ke as useSearchStore
};
//# sourceMappingURL=index.mjs.map
